// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-unavailable';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M.576 12.96c0-2.808 2.304-5.04 5.04-5.04.648 0 1.368.144 2.016.432M2.52 3.672c0 1.728 1.368 3.096 3.096 3.096S8.712 5.4 8.712 3.672 7.344.576 5.616.576 2.52 1.944 2.52 3.672zm5.904 9.288c0 2.52 2.016 4.464 4.464 4.464s4.464-2.016 4.464-4.464-2.016-4.464-4.464-4.464-4.464 1.944-4.464 4.464zm6.192-1.728-3.384 3.384m0-3.384 3.384 3.384'
  />
);

export const viewBox = '0 0 18 18';
